// Simple stopword list for English
const STOPWORDS = new Set([
  "the", "and", "a", "an", "of", "to", "in", "for", "on", "with", "at", "by", "from", "up", "about", "into", "over", "after", "under", "above", "below", "is", "are", "was", "were", "be", "been", "being", "have", "has", "had", "do", "does", "did", "but", "if", "or", "because", "as", "until", "while", "can", "will", "just", "should", "could", "would", "may", "might", "so", "than", "too", "very", "this", "that", "these", "those", "it's", "i", "you", "he", "she", "it", "we", "they", "them", "his", "her", "their", "our", "your", "my", "me", "him", "who", "whom", "which", "what", "when", "where", "why", "how"
]);

export function extractKeywords(text: string, exclude: string[] = [], max = 5): string[] {
  if (!text) return [];
  const words = text
    .toLowerCase()
    .replace(/[^a-z0-9\s]/g, " ")
    .split(/\s+/)
    .filter(w => w && !STOPWORDS.has(w) && w.length > 2 && !exclude.includes(w));
  const freq: Record<string, number> = {};
  for (const w of words) freq[w] = (freq[w] || 0) + 1;
  return Object.entries(freq)
    .sort((a, b) => b[1] - a[1])
    .slice(0, max)
    .map(([w]) => w);
} 